exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notificationSelector__container___10fdo .notificationSelector__titleText___1xN6- {\n  color: #8e8e8e; }\n\n.notificationSelector__container___10fdo .notificationSelector__notify___3trZY {\n  display: flex;\n  align-items: center; }\n\n.notificationSelector__container___10fdo .notificationSelector__radioContainer___2a02Y label {\n  border-radius: 20px;\n  margin-right: 10px;\n  margin-top: 10px;\n  border: 1px solid #8e8e8e;\n  font-size: 12px; }\n\n.notificationSelector__container___10fdo .notificationSelector__radioContainer___2a02Y .ant-radio-button-wrapper-checked {\n  border-color: #f94144;\n  -webkit-box-shadow: none;\n  box-shadow: none; }\n\n.notificationSelector__container___10fdo .notificationSelector__radioContainer___2a02Y label::before {\n  display: none; }\n\n.notificationSelector__container___10fdo img {\n  margin-right: 10px; }\n", ""]);

// exports
exports.locals = {
	"container": "notificationSelector__container___10fdo",
	"titleText": "notificationSelector__titleText___1xN6-",
	"notify": "notificationSelector__notify___3trZY",
	"radioContainer": "notificationSelector__radioContainer___2a02Y"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/SavedSearchPage/ListSavedSearch/ListSavedSearchWeb/SavedSearchItem/NotificationSelector/notificationSelector.scss
// module id = 4226
// module chunks = 6